import BpkText, {
  TEXT_STYLES,
} from '@skyscanner/backpack-web/bpk-component-text';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import SingleGroupAmenities from '../SingleGroupAmenities';

import type { HotelAmenityCategory } from '@shared/types/hotel-content';

import STYLES from './AmenityGroups.module.scss';

import SeeMoreLess from '@shared/ui/components/SeeMoreLess/SeeMoreLess';

const SHOW_MAX_AMENITIES_NUM = 10;

const cls = cssModules(STYLES);

const AmenityGroups = ({
  dialog = false,
  groups,
  seeMoreLess = false,
}: {
  groups: HotelAmenityCategory[];
  dialog?: boolean;
  seeMoreLess?: boolean;
}) => {
  if (groups.length === 0) {
    return null;
  }

  return (
    <div className={cls('AmenityGroups__groups')}>
      {groups.map((group) => {
        const { displayName, items } = group;
        const hasMore = items.length > SHOW_MAX_AMENITIES_NUM;
        const defaultPart = items.slice(0, SHOW_MAX_AMENITIES_NUM);
        const morePart = items.slice(SHOW_MAX_AMENITIES_NUM);

        return (
          <div key={displayName} className={cls('AmenityGroups')}>
            <div
              className={cls(
                'AmenityGroups__single',
                dialog && 'AmenityGroups__single--dialog',
              )}
            >
              <BpkText
                textStyle={TEXT_STYLES.subheading}
                className={cls(
                  'AmenityGroups__content',
                  dialog && 'AmenityGroups__content--dialog',
                )}
              >
                {displayName}
              </BpkText>
              {seeMoreLess ? (
                <SingleGroupAmenities items={defaultPart} />
              ) : (
                <SingleGroupAmenities items={items} />
              )}

              {seeMoreLess && hasMore && (
                <SeeMoreLess
                  link
                  buttonClassName={cls('AmenityGroups__seeMoreBtn')}
                >
                  <div className={cls('AmenityGroups__morePart')}>
                    <SingleGroupAmenities items={morePart} />
                  </div>
                </SeeMoreLess>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default AmenityGroups;
